export default "__VITE_ASSET__76917752__"